import React from "react";
import arrowDownIcon from "../../../assets/images/arrow-down.svg";
import info from "../../../assets/images/info.svg";
import { formatPhoneNumber } from "../../../utils/helper";
import FormField from "./FormField";

interface ProfileFormProps {
    openSpecializationSheet: () => void;
    openCitySheet: () => void;
    openQualificationSheet: () => void;
    handleQualificationUpdate: (e: any[]) => void;
    handleCityUpdate: (e: any) => void,
    setEmail: (email: any) => void,
    qualificationIds: any[],
    email: any,
    qualifications: any[],
    cities: any[],
    selectedSpeciality: any;
    selectedCity: any;
    selectedQualification: any;
    doctorDetails: any;
    isSpecialityEditable: boolean;
    selectedQualifications: any[];
    removeQualification: (e: any) => void;
    removeQualificationByCode: (e: any) => void;
}

const ProfileForm: React.FC<ProfileFormProps> = ({
    setEmail,
    email,
    selectedSpeciality,
    selectedCity,
    doctorDetails,
    isSpecialityEditable,
    openCitySheet,
    selectedQualifications,
    removeQualification,
    openQualificationSheet
}) => {
    const mobileNumber = formatPhoneNumber(doctorDetails?.mobileNumber || "");
    return (
        <form className="flex flex-col self-center mt-6 w-full px-6">
            <div className="flex flex-col w-full">
                <FormField label={'Your Full Name'} value={doctorDetails?.name || ''} disabled={true} onChange={() => {
                }} />
            </div>
            <div className="flex flex-col w-full">
                <FormField label={'Phone'} value={mobileNumber || ''} onChange={() => {
                }} disabled={true} />
            </div>
            <div className="flex mt-2 flex-col w-full">
                <FormField label={'Core Specialisation'} value={selectedSpeciality?.displayName || ''} onChange={() => {
                }} disabled={true} />
                {isSpecialityEditable && (
                    <div className="flex items-center gap-x-2 bg-[#FDF7D7] p-2 rounded-2xl mt-4">
                        <img loading="lazy" src={info} alt="info" />
                        <span className="text-xs text-left">
                            <span className="font-medium">Please note:</span> Once you select
                            your speciality, it cannot be edited.
                        </span>
                    </div>
                )}
            </div>
            {/* city */}
            <div className="flex flex-col self-center mt-2 w-full">
                <label
                    htmlFor="city"
                    className="flex-1 shrink gap-2.5 px-2 w-full text-sm leading-loose text-gray-500 text-left"
                >
                    City <span className="text-red-500">*</span>
                </label>
                <div
                    className="flex items-center mt-1 w-full text-base text-gray-500 bg-white rounded-xl border border-solid border-slate-300 min-h-[56px]">
                    <div
                        onClick={openCitySheet}
                        className="flex flex-1 shrink gap-2 justify-between items-center px-3 py-2 basis-0 min-w-[240px] size-full"
                    >
                        <span>
                            {selectedCity?.cityName !== undefined ? selectedCity?.cityName + ', ' + selectedCity?.state : "Select City"}
                        </span>
                        <img loading="lazy" src={arrowDownIcon} alt="Arrow Down" />
                    </div>
                </div>
            </div>
            {/* qualification */}
            <div className="flex flex-col self-center mt-3 w-full">
                <label
                    htmlFor="qualification"
                    className="flex-1 shrink gap-2.5 px-2 w-full text-sm leading-loose text-gray-500 text-left"
                >
                    Qualification <span className="text-red-500">*</span>
                </label>
                <div
                    className="flex items-center mt-1 w-full text-base text-gray-500 bg-white rounded-xl border border-solid border-slate-300 min-h-[56px]">
                    <div
                        className="flex flex-1 shrink gap-2 justify-between items-center px-3 py-2 basis-0 min-w-[240px] size-full"
                        onClick={openQualificationSheet}
                    >
                        <span className={'text-left'}>
                            {selectedQualifications.length > 0 ? selectedQualifications.map((q: any) => (
                                <span id={q.id} onClick={() => removeQualification(q.id)}
                                    className={'quali-button'}>{q.code} &times;</span>)) : "Select Qualifications"}
                        </span>
                        <img loading="lazy" src={arrowDownIcon}
                            alt="Arrow Down" />
                    </div>
                </div>
            </div>
            {/* email */}
            <div className="flex flex-col self-center mt-3 w-full">
                <FormField label={'Email'} placeholder={'Enter your email id (optional)'} value={email || ""}
                    onChange={(e) => setEmail(e)} />
            </div>
        </form>
    );
};

export default ProfileForm;
